module.exports = __webpack_public_path__ + "static/media/deliveryTruck.f28f35f2.svg";